import { render, staticRenderFns } from "./AvatarStatusCompromissoSeparacao.vue?vue&type=template&id=c0272f9a&"
import script from "./AvatarStatusCompromissoSeparacao.vue?vue&type=script&lang=js&"
export * from "./AvatarStatusCompromissoSeparacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports